module.exports = __webpack_public_path__ + "static/assets/0f291d9538dac80e8110ecd8b68b3de1.otf";